import { inmunetApi } from '../../../api';

export const getEstudio = async() => {

    try {

        const { data } = await inmunetApi.get(`/consulta/estudios?paginacion=false`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.estudios;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};